import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface MetricTooltipProps {
    /** 提示文本内容 */
    content: string;
    /** 图标大小，默认14px */
    iconSize?: number;
}

/**
 * 指标提示组件
 * 显示一个信息图标，鼠标悬浮时显示提示内容
 */
const MetricTooltip: React.FC<MetricTooltipProps> = ({ content, iconSize = 14 }) => {
    return (
        <Tooltip
            title={content}
            placement="top"
            overlayStyle={{ maxWidth: 400 }}
            overlayInnerStyle={{ whiteSpace: 'pre-line' }}
        >
            <InfoCircleOutlined
                style={{
                    fontSize: iconSize,
                    color: '#1890ff',
                    cursor: 'help',
                    marginLeft: 4
                }}
            />
        </Tooltip>
    );
};

export default MetricTooltip;

